export default "__VITE_ASSET__Bol_$b2X__"